import React, {useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

//Routing
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

//Bootstrap imports
import {Container, Row, Col, CardDeck, Card} from 'react-bootstrap';

//Icons
import SocialLogo from 'social-logos';

//Other imports
import PresskitCard from './components/PresskitCard.component';
import TopNavbar from './components/TopNavbar.component';
import Footer from './components/Footer.component';

//Presskit data
import LBLjson from './Presskit Files/LBL';
import OBGjson from './Presskit Files/OBG';
import GBOXjson from './Presskit Files/GBOX';
import Lostwickjson from './Presskit Files/Lostwick';

//Images
import HomeImg from './source/OBG Key Art/HeroCapsule.png'

function App() {



  return (

    <div>
      <Router>

        <TopNavbar/>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

            <Switch>

                <Route path="/Presskits">

                  <Container>

                    <Row>
                      <h1 id = "presskitTitle"variant = "light">Presskits</h1>
                    </Row>
                    <hr id = "titleSeparator"></hr>

                    <Row>

                      <CardDeck>
                        <PresskitCard data = {LBLjson}/>
                        <PresskitCard data = {GBOXjson}/>
                        <PresskitCard data = {OBGjson}/>
                      </CardDeck>

                    </Row>

                  </Container>

                </Route>

                <Route path = "/Games">

                <Container>

                  <Row>
                    <h1 id = "presskitTitle"variant = "light">Games</h1>
                  </Row>
                  <hr id = "titleSeparator"></hr>

                  <Row>

                  <div id = "steamContainer">

                      <iframe src="https://store.steampowered.com/widget/1033780/" frameborder="0" width="646" height="190"></iframe>
                      <iframe src="https://store.steampowered.com/widget/1345040/" frameborder="0" width="646" height="190"></iframe>
                      <iframe src="https://store.steampowered.com/widget/1276810/" frameborder="0" width="646" height="190"></iframe>

                  </div>

                  </Row>

                </Container>




                </Route>


                <Route path="/">

                <Container>

                  <Row>
                    <h1 id = "presskitTitle"variant = "light">Home</h1>
                  </Row>
                  <hr id = "titleSeparator"></hr>

                  <Row>
                    <Col>
                      <p id  ="homeparagraph">
                      Conradical Games is an indie studio that focuses on creating
                      games that rethink genre conventions.
                      <br></br>
                      <br></br>
                      Currently, work is being done on finishing The Outbound Ghost and porting Lootbox Lyfe to additional platforms.
                      <br></br>
                      <br></br>
                      If you have any queries about anything regarding Conradical Games, you can
                      ask by emailing conrad@conradicalgames.com, or DMing <a href = "https://twitter.com/ConradicalGames" target="_blank">@ConradicalGames</a> on twitter.

                      </p>
                    </Col>

                    <Col>
                      <img id = "HomeImg" src = {HomeImg}></img>
                    </Col>

                  </Row>

                </Container>


                </Route>


            </Switch>
            <br></br>
            <br></br>
            <br></br>
            <Footer/>

        </Router>

      </div>


  );
}



export default App;
